import React, {useEffect, useState} from 'react';
import {IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonToolbar} from '@ionic/react';
import AssignmentDataCard from "../components/AssignmentDataCard";
import AssignmentDetail from "../components/AssignmentDetail";
import AssignmentFilterSidebar from "../components/AssignmentFilterSidebar";
import {FacebookLoader} from "../components/Loader/FacebookLoader";
import {Virtuoso} from "react-virtuoso";
import NoDataFoundOrSelectedDiv from "../components/NoDataFoundOrSelectedDiv";
import useStore from "../zustand/useStore";
import {actionToGetRfpAssignmentDataByFilter} from "../apiHelpers/CommonAction";
import {_getExpiryDateFromRange} from "../apiHelpers/CommonHelper";
import {arrowBack} from "ionicons/icons";


export default function AssignmentDesktopPage({isOpen,onDidDismiss,myPostsData}) {
    const {rfpAssignmentDataState, selectedRetainership,
        selectedExpiryDate,
        selectedPrice,
        selectedAssignmentLocation
    } = useStore();
    const {loading,assignments } = rfpAssignmentDataState;
    const [assignmentDetail, setAssignmentDetail] = useState({});
    const isFetchingRef = React.useRef(false); // prevent multiple calls

    const callFunctionToFilterAssignmentPosting = async (isLoad = true)=>{
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        const payload = {};
        if (selectedRetainership) payload.retainership = selectedRetainership;
        if (selectedExpiryDate) payload.expiry_date = _getExpiryDateFromRange(selectedExpiryDate);
        if (selectedPrice) payload.price_max = selectedPrice;
        if (selectedAssignmentLocation.length > 0) payload.location = selectedAssignmentLocation;
        payload.me_mode = !!myPostsData;
        await actionToGetRfpAssignmentDataByFilter(isLoad,payload);
        isFetchingRef.current = false;
    }

    useEffect(() => {
        if(assignments?.length){
            setAssignmentDetail(assignments[0]);
        }else{
            setAssignmentDetail({});
        }
    },[assignments])

    const handleDetailItemClick = (jobDetail)=>{
        setAssignmentDetail(jobDetail);
    }

    useEffect(() => {
        if(isOpen){
            callFunctionToFilterAssignmentPosting();
        }
    },[isOpen])

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            className={"modal_in_detail_desktop_full_view"}
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <div className="job_detail_sheet_header_text">
                        <div className="job-basic-info-image">
                            <span className="job-basic-info-text">
                                {myPostsData ? 'My' : ''} Assignment Posts List
                            </span>
                        </div>
                    </div>
                </IonToolbar>
            </IonHeader>
            <IonContent className="job-portal-desktop page-contenaat">
                <div className="job-portal-container three-panel-grid">
                    {/* Filter Sidebar */}
                    <aside className="filter-sidebar">
                        <AssignmentFilterSidebar myPostsData={myPostsData}/>
                    </aside>

                    {/* Job List */}
                    <section className="job-list-section">
                        {(loading) ?
                            <div className={'job-list'}>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className={'job-card'}>
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                            :
                            (assignments && assignments?.length > 0) ?
                                <Virtuoso
                                    className={'job-list'}
                                    data={assignments}
                                    style={{height: 'calc(100vh - 115px)'}}
                                    endReached={() => callFunctionToFilterAssignmentPosting(false)}
                                    overscan={5}
                                    itemContent={(index, assignment) => (
                                        <AssignmentDataCard
                                            assignment={assignment}
                                            key={assignment.id}
                                            selectedId={assignmentDetail?.id}
                                            handleDetailItemClick={handleDetailItemClick}
                                        />
                                    )}
                                />
                                :
                                <div className="job-list">
                                    <NoDataFoundOrSelectedDiv/>
                                </div>
                        }
                    </section>

                    {/* Job Details */}
                    <aside className="job-details-sidebar">
                        {(assignmentDetail?.id) ?
                            <AssignmentDetail assignmentDetail={assignmentDetail}/>
                            :
                            <NoDataFoundOrSelectedDiv isDetailPanel={true}/>
                        }
                    </aside>
                </div>
            </IonContent>
        </IonModal>
    );
}
